import { env } from 'utils/envManager'

export const updateNotificationsService = async ({
	id,
	token,
}: {
	id: string | null
	token: string | null
}): Promise<void> => {
	let response

	const baseUrl = `/ws-customer-notifications/v1/${id}/mark-as-read`
	const url = new URL(baseUrl, env.NEXT_PUBLIC_SITE_BASE_URL)

	if (token) {
		response = await fetch(url.href, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			next: { revalidate: 0 },
		})

		if (response.ok) {
			return
		}
	}

	console.error(
		`[Customer Notifications Service - Update Notifications] failed to fetch.\n ${response?.status}: ${response?.statusText}`
	)
}
